import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {connectEvent, connectI18n} from '../../connects';
import {Redirect} from 'react-router-dom';
import Screen from '../Screen';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import Scrollable from '../../elements/Scrollable';
import Blocklink from '../../elements/Blocklink';

class LiveVotingSessionSelection extends React.Component {
    render() {
        const {i18n} = this.props;

        if (!this.props.votingSessions.length) {
            return <Redirect to={['/events', this.props.event.id].join('/')} />;
        } else if (this.props.votingSessions.length == 1) {
            return <Redirect to={[location.pathname, this.props.votingSessions[0].id].join('/')} />;
        }

        let header = (
            <div>
                <TopBarEvent event={this.props.event} />
                <hr />
            </div>
        );

        return (
            <Screen header={header}>
                <Scrollable>
                    <div className="content">
                        <br />
                        <p className="text main">{i18n['livevoting.sessions']}?</p>
                        <br />
                    </div>
                    <div className="indent">
                        {this.props.votingSessions.map(session => (
                            <Blocklink
                                next="next"
                                className="marginBottom"
                                href={'./' + session.id}
                                customColor={this.props.event.settings.secondary_color}
                                key={session.id}>
                                {session.name}
                            </Blocklink>
                        ))}
                    </div>
                </Scrollable>
            </Screen>
        );
    }
}

const ConnectedScreen = compose(
    connectEvent,
    connectI18n,
    connect((state, props) => ({
        votingSessions: _(state)
            .get(`events[${props.event.id}].voting.sessions`, [])
            .filter(voting => voting.is_open),
    }))
)(LiveVotingSessionSelection);

export default props => <ConnectedScreen {...props.match.params} />;
